import React, { ChangeEvent, useCallback, useState } from 'react'
import { checkErrors, checkErrorsWhenSubmit, ValuesForm } from '../../../../utils/verifications/Forms'
import { MyYup } from '../../../../utils/verifications/myYup'
import GeneralInputTitle from '../../../UIcomponents/GeneralInputTitle/GeneralInputTitle'
import InputList from '../../../UIcomponents/InputList/InputList'
import ItemListEmail from './ItemListEmail/ItemListEmail'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./CreateScheduleEmailForm.css"
import { faClock } from '@fortawesome/free-regular-svg-icons'
import LoadingSpinner from '../../../LoadingSpinner'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../redux/store/store'
import useGetScheduleText, { getScheduleFrecuency } from '../../../hooks/useGetScheduleText/useGetScheduleText'
import { Schedule } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import { BodyScheduleEmails, createScheduleEmail, updateScheduleEmail, UpdateScheduleEmailBody } from '../../../../utils/requestsUtils/functionsRequests/emails/emailsFunctions'
import { DeviceEmail, FrecuencyEmail, ScheduleEmail, setUpdatedScheduleEmailReducer, TopicEmail, UpdateScheduleEmailsThunk } from '../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'
import { ScheduleFrecuency } from '../../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import ConModalSelectScheduleEmail from '../ConModalSelectScheduleEmail/ConModalSelectScheduleEmail'
import ConModalResumeScheduleEmail from '../ConModalResumeScheduleEmail/ConModalResumeScheduleEmail'
import ConModalPreviewEmail from '../ConModalPreviewEmail/ConModalPreviewEmail'
import { PreviewEmail } from '../ConModalResumeScheduleEmail/ModalResumeScheduleNotification/ModalResumeScheduleEmail'


type CreateScheduleEmailFormProps = {
    type: "Edit",
    scheduleEmail: ScheduleEmail
} | { type: "Create" }

const CreateScheduleEmailForm = (props: CreateScheduleEmailFormProps) => {

    const { t, i18n } = useTranslation()
    const dispatch = useAppDispatch()


    const devices: DeviceEmail[] = [
        { id: "All", text: t(`Emails:schedule:device:${"All"}`) },
        { id: "Just_Desktop", text: t(`Emails:schedule:device:${"Just_Desktop"}`) },
        { id: "Just_App", text: t(`Emails:schedule:device:${"Just_App"}`) },
    ]
    const [device, setDevice] = useState<DeviceEmail>(props.type === "Create" ? devices[0] : (devices.find(s => s.id === props.scheduleEmail.device) ?? devices[0]))

    const topics: TopicEmail[] = [
        { id: "general-topic", text: t(`Emails:schedule:topic:${"general-topic"}`), className: "" },
        { id: "gim-topic", text: t(`Emails:schedule:topic:${"gim-topic"}`), className: "color-gim" },
        { id: "gimmer-topic", text: t(`Emails:schedule:topic:${"gimmer-topic"}`), className: "color-gimmer" },
    ]
    const [topic, setTopic] = useState<TopicEmail>(props.type === "Create" ? topics[0] : (topics.find(s => s.id === props.scheduleEmail.topic) ?? topics[0]))


    const frecuencies: FrecuencyEmail[] = [
        { id: "One_time", text: t(`Emails:schedule:frecuency:${"One_time"}`),  },
        { id: "Every_day", text: t(`Emails:schedule:frecuency:${"Every_day"}`), },
        { id: "Every_week", text: t(`Emails:schedule:frecuency:${"Every_week"}`), },
        { id: "Every_month", text: t(`Emails:schedule:frecuency:${"Every_month"}`),  },
    ]
    const [frecuency, setFrecuency] = useState<FrecuencyEmail>(props.type === "Create" ? frecuencies[0] : (frecuencies.find(s => s.id === props.scheduleEmail.frecuency) ?? frecuencies[0]))

    const [showModalPreview, setShowModalPreview] = useState<PreviewEmail | undefined>(undefined)
    const [showModal, setShowModal] = useState(false)
    const [showModalResume, setShowModalResume] = useState(false)

    const [loading, setLoading] = useState(false)

    const [inputValues, setInputValues] = useState<ValuesForm>({
        subject: { error: "", value: props.type === "Create" ? "" : props.scheduleEmail.subject, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isRequired().isString().AllValidCharacters()},
        bodyEmail: { error: "", value: props.type === "Create" ? "" : props.scheduleEmail.bodyEmail, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18n.language, dv).isString().AllValidCharacters()},
    })

    let initialSchedule: ScheduleFrecuency | undefined = undefined

    if(props.type === "Edit"){
        initialSchedule = getScheduleFrecuency(props.scheduleEmail.frecuency, props.scheduleEmail.schedule)
    } 

    const [schedule, setSchedule] = useState<ScheduleFrecuency | undefined>(initialSchedule)

    const { alreadyExecutedOneTime } = useGetScheduleText(
        props.type === "Create"  
        ? { type: "NOT_SCHEDULE"}
        : (schedule ? { type: "ScheduleFrecuency", frecuencyId: props.scheduleEmail.frecuency, schedule: schedule } : { type: "NOT_SCHEDULE"})
    )

    const onShowPreview = useCallback(
        (type: PreviewEmail) => {
           setShowModalPreview(type) 
        },
        [],
    )
    
    const onCloseModalPreview = useCallback(
        () => {
           setShowModalPreview(undefined) 
        },
        [],
    )

    const onChangeValueInput = (newEvent: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        checkErrors(newEvent, inputValues, setInputValues)
    }

    const onChangeFocusInput = (name: string) => {
        setInputValues({...inputValues, [name]: {...inputValues[name], touched: true}}) 
    }


    const onChangeDevice = (item: DeviceEmail) => {
        setDevice(item)
    }

    const onChangeTopic = (item: TopicEmail) => {
        setTopic(item)
    }

    const onChangeFrecuency = (item: FrecuencyEmail) => {
        setFrecuency(item)
        setSchedule(undefined)
    }

    const onShowModal = useCallback(
        () => {
            setShowModal(true)
        },
        [],
    )

    const onCloseModal = useCallback(
        () => {
            setShowModal(false)
        },
        [],
    )


    const onShowResumeModal = useCallback(
        () => {
            setShowModalResume(true)
        },
        [],
    )

    const onCloseResumeModal = useCallback(
        () => {
            setShowModalResume(false)
        },
        [],
    )
    
    const onSetScheduleEmail = useCallback(
        (schedule: ScheduleFrecuency) => {
            setSchedule(schedule)
        },
        [],
    )

    const onResume = () => {

        
        let existsError = false;
        for(const nameInput in inputValues){
            if(checkErrorsWhenSubmit(nameInput, inputValues))
                existsError = true
        }
        setInputValues({...inputValues})

        if(existsError)
            return

        if(!schedule || !device || !topic || !frecuency)
            return

        onShowResumeModal()

    }


    const getScheduleFormatted = (): Schedule => {
        if(!schedule){
            throw(`You must select an hour`)
        }
        const localHour = moment(schedule.utcHour).hour()
        
        if(schedule.id === "One_time"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: moment.utc(schedule.utcDate).local().hour(localHour).utc().date(),
                dayOfWeek: "?",
                month: moment(schedule.utcHour).utc().month() + 1,
                year: moment(schedule.utcHour).utc().year(),
            }
        }else if(schedule.id === "Every_day"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: "*",
                dayOfWeek: "?",
                month: "*",
                year: "*",
            }
        }else if(schedule.id === "Every_week"){
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: "?",
                dayOfWeek: schedule.weekDay,
                month: "*",
                year: "*",
            }
        }else{
            return {
                minutes: moment(schedule.utcHour).utc().minutes(),
                hour: moment(schedule.utcHour).utc().hour(),
                dayOfMonth: moment.utc(schedule.utcDate).local().hour(localHour).utc().date(),
                dayOfWeek: "?",
                month: "*",
                year: "*",
            }
        }
    }

    const onSubmit = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

        e.preventDefault()
        console.log("alreadyExecutedOneTime", alreadyExecutedOneTime, device, topic, frecuency, schedule)
        if(!schedule || !device || !topic || !frecuency || alreadyExecutedOneTime)
            return

        
        try {
            const scheduleFormatted = getScheduleFormatted()
            
            const scheduleEmail: BodyScheduleEmails = {
                bodyEmail:      inputValues["bodyEmail"].value,
                topic:          topic.id,
                schedule:       scheduleFormatted,
                subject:        inputValues["subject"].value,
                frecuency:      frecuency.id,
                device:         device.id
            }

            
            if(props.type === "Create"){
                setLoading(true)
                createScheduleEmail(scheduleEmail)
                .then(() => {
                    onCloseResumeModal()
                    onCloseModalPreview()
                }).catch(() => {
                    alert("Error")
                }).finally(() => {
                    setLoading(false)
                })
            }else{
                const body: UpdateScheduleEmailBody = {
                    bodyEmail:                inputValues["bodyEmail"].value,
                    topic:                    topic.id,
                    subject:                  inputValues["subject"].value,
                    schedule:                 scheduleFormatted,
                    frecuency:                frecuency.id,
                    device:                   device.id
                }

                setLoading(true)
                updateScheduleEmail(props.scheduleEmail.id, body)
                .then(() => {
                    dispatch( setUpdatedScheduleEmailReducer({ id: props.scheduleEmail.id, body }) )
                    onCloseResumeModal()
                    onCloseModalPreview()
                }).catch(() => {
                    alert("Error")
                }).finally(() => {
                    setLoading(false)
                })

                
            }
            
        } catch (error) {
            console.log("error", error)
            setLoading(false)
        }


    }

    return (
        <div className="">

            <p className="fs-12 mb-4 fw-600 mt-20">
                {t("Emails:schedule:index:label_02")}
            </p>
            <GeneralInputTitle 
                title={t("Emails:schedule:index:label_03") ?? ""}
                name={"subject"}
                value={inputValues["subject"].value}
                onChange={onChangeValueInput}
                onFocus={onChangeFocusInput}
                placeholder={t("Emails:schedule:index:label_04")}
                error={inputValues["subject"].error}
                width="100%"
                hideTitle={true}
                titleAbove={true}
                textArea={{ height: "6rem" }}
            />

            <p className="fs-12 mb-4 mt-10">
                {t("Emails:schedule:index:label_05")}
            </p>
            <GeneralInputTitle 
                title={`Message`}
                name={"bodyEmail"}
                value={inputValues["bodyEmail"].value}
                onChange={onChangeValueInput}
                onFocus={onChangeFocusInput}
                placeholder={t("Emails:schedule:index:label_06")}
                error={inputValues["bodyEmail"].error}
                width="100%"
                hideTitle={true}
                titleAbove={true}
                textArea={{ height: "6rem" }}
            />


            <div className="flex">
                
                <div className="mr-20">
                    <p className="fs-14 mb-8 mt-10">
                        {t("Emails:schedule:index:label_07")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={devices.find(s => s.id === device.id)?.text ?? ""}  
                            width={"13rem"}
                            fontSize="fs-11"
                            heightList="7rem"
                            height="3.4rem"
                        >
                            {
                                devices.filter(i => i.id !== device.id).map((notif: DeviceEmail) => {
                                    return(
                                        <ItemListEmail 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeDevice}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

                <div className="mr-30">
                    <p className="fs-14 mb-8 mt-10">
                        {t("Emails:schedule:index:label_08")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={topics.find(s => s.id === topic.id)?.text ?? ""}  
                            width={"13rem"}
                            fontSize="fs-11"
                            heightList="7rem"
                            height="3.4rem"
                        >
                            {
                                topics.filter(i => i.id !== topic.id).map((notif: TopicEmail) => {
                                    return(
                                        <ItemListEmail 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeTopic}
                                            className={notif.className}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

            </div>

            <div className="line-gray-help mt-18 mb-20" />

            <div className="flex flex-jc-sb flex-ai-end">
                
                <div className="mr-30">
                    <p className="fs-14 mb-8">
                        {t("Emails:schedule:index:label_09")}
                    </p>
                    <div className="padding-to-show-error">
                        <InputList 
                            text={frecuencies.find(s => s.id === frecuency.id)?.text ?? ""}  
                            width={"16rem"}
                            fontSize="fs-11"
                            heightList="10rem"
                            height="3.4rem"
                        >
                            {
                                frecuencies.filter(i => i.id !== frecuency.id).map((notif) => {
                                    return(
                                        <ItemListEmail 
                                            key={notif.id}
                                            item={notif}
                                            text={notif.text}
                                            onSelect={onChangeFrecuency}
                                        />
                                    )
                                })
                            }
                        </InputList>
                    </div>
                </div>

                <div className="flex flex-jc-end mb-12">
                    <button
                        onClick={onShowModal}
                    >
                        <FontAwesomeIcon 
                            icon={faClock}
                            className={`fs-28 mr-20 ${(schedule && !alreadyExecutedOneTime) ? "c-black" : "color-error"}`}
                        />
                    </button>

                    <button
                        onClick={onResume}
                        className="validate-btn-notif"
                    >
                        {t("Emails:schedule:index:label_10")}
                    </button>
                </div>

            </div>

            {
                showModal
                ? 
                <ConModalSelectScheduleEmail 
                    frecuencyId={frecuency.id}
                    onCloseModal={onCloseModal}
                    onSet={onSetScheduleEmail}
                    //schedule={schedule}
                />
                : null
            }

            {
                (showModalResume && frecuency && device && schedule)
                ? 
                <ConModalResumeScheduleEmail
                    frecuency={frecuency}
                    topic={topic}
                    device={device}
                    schedule={schedule}
                    subject={inputValues["subject"].value}
                    bodyEmail={inputValues["bodyEmail"].value}
                    onPreview={onShowPreview}
                    onCloseModal={onCloseResumeModal}
                />
                : null
            }

            {
                (showModalPreview !== undefined)
                ? 
                <ConModalPreviewEmail
                    subject={inputValues["subject"].value}
                    bodyEmail={inputValues["bodyEmail"].value}
                    onSubmit={onSubmit}
                    onCloseModal={onCloseModalPreview}
                    previewEmail={showModalPreview}
                />
                : null
            }

            { loading ? <LoadingSpinner fullPage={true} /> : null}

        </div>
    )
}

export default React.memo( CreateScheduleEmailForm )